import { render, staticRenderFns } from "./OneImgUpload.vue?vue&type=template&id=afbec258"
import script from "./OneImgUpload.vue?vue&type=script&lang=js"
export * from "./OneImgUpload.vue?vue&type=script&lang=js"
import style0 from "./OneImgUpload.vue?vue&type=style&index=0&id=afbec258&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports